import robot from "../../../assets/img/landings/a2b/icons/1.svg";
import shiping from "../../../assets/img/landings/a2b/icons/2.svg";
import logistics from "../../../assets/img/landings/a2b/icons/3.svg";
import seo from "../../../assets/img/landings/a2b/icons/4.svg";
import doc from "../../../assets/img/landings/a2b/icons/5.svg";
import service from "../../../assets/img/landings/a2b/service.png";
import serviceSmall from "../../../assets/img/landings/a2b/serviceSmall.png";
import circles from "../../../assets/img/landings/circles.svg";
import circles_light from "../../../assets/img/landings/circles_light.svg";

export const data = {
  hero: {
    title: "A2B Direct",
    subtitle: "ONLINE CARGO LOGISTICS",
    text: [
      "A2B Direct is a B2B logistics marketplace that brings together cargo owners (customers) and freight forwarders (carriers). It brings the simplicity of Uber-like apps into the complex world of freight logistics. The A2B platform allows direct interaction between the carrier and the cargo owner at all stages of cargo delivery.",
    ],
  },

  challenge: {
    title: "Challenge",
    text: [
      "The main problem of cargo transportation is half-empty trucks. Due to the lack of a mechanism that would connect the goods of different cargo owners, the trucks are not fully loaded which transforms into profit losses due to inefficient fuel consumption and carrier time.",
    ],
  },

  solutions: {
    title: "Solutions",
    text: [
      "Create an algorithm for combining loads of different owners in one truck.",
    ],
    image: null,
    bgr: circles,
    list: [
      {
        imageData: {
          image: robot,
          width: "48",
          height: "48",
        },
        title: "LTL",
        text: "Combining several customer requests into a single order based on the date, destination, type of cargo, urgency, etc. The complex algorithm processing request while building an efficient route for the most optimal delivery time and distributed cargo load.",
      },
      {
        imageData: {
          image: shiping,
          width: "48",
          height: "48",
        },
        title: "AI",
        text: "Automatic determination of optimal rates for the client and the carrier. Pricing algorithm updates future rates automatically based on previous successful delivery.",
      },
      {
        imageData: {
          image: logistics,
          width: "48",
          height: "42",
        },
        title: "Collaboration with drivers",
        text: "If the system recognizes that a new cargo request is on the route of a specific truck, A2B sends a notification to the carrier with the option to pick up the cargo.",
      },
      {
        imageData: {
          image: seo,
          width: "48",
          height: "48",
        },
        title: "Flexible Pricing and bidding",
        text: "Our system picks the driver based on the best-offered quote in an anonymous competition.",
      },
      {
        imageData: {
          image: doc,
          width: "48",
          height: "48",
        },
        title: "Integrated management system",
        text: "Such as RabbitMQ, A2B platform consolidates accounting, logistics, finance, and insurance documentation in one place for convenience and efficiency.",
      },
    ],
  },
  microservices: {
    title: "Microservices",
    bgr: circles_light,
    text: [
      "A2B modularized architecture enables continuous optimization of existing features and addition of new ones without drastic consequences of existing functionality.",
    ],
    slides: [
      {
        title: "Application management service",
        text: "The service processes the application, auto-completes the fields, and determines whether it can be used in the LTL algorithm.",
      },
      {
        title: "Pricing",
        text: "Embedded ML and AI enable flexible pricing models which results in a significant increase in business profits.",
      },
      {
        title: "Auth",
        text: "Security is a big concern for both the carriers as well as businesses. That’s why Agilistry has architected the most secure and customer-friendly onboarding and login process.",
      },
      {
        title: "Notifications",
        text: "Businesses want to know the condition and location of their freight. That’s why a robust notification system was very essential for success.",
      },
      {
        title: "Bidding",
        text: "Dynamic pricing and bidding features were the key success factors for A2B business model. Thus, Agilistry UX designers and engineers spend countless hours making these features robust and bug-free.",
      },
      {
        title: "Waybills",
        text: "Automatic waybills are the bread and butter of the logistics business. Marrying business and carrier contracts, purchases orders, invoices, insurance could be a troublesome and time consuming process. Not mentioning it all has to be at fingertips of the driver on their mobile device. We’ve done it all while obfuscating all complexity underhood of isolated microservice which enabled A2B to customize and altern any future business documentation.",
      },
      {
        title: "GeoTracking",
        text: "By utilizing NodeJS, Agilistry team has built a lightweight microservice responsible for tracking geolocation of the trucks during transit while presenting the current location to the customer.",
      },
    ],
  },
  service: { image: service, serviceSmall },
};
